import type { HttpClient } from '../../../types/api';
import type { APIResponse } from '../../../types/api';

export type PostNotificationParams = {
  permission: number;
};

export type PostNotificationResponse = APIResponse<{
  permission: number;
}>;

export const postNotification = async (params: PostNotificationParams, httpClient: HttpClient) => {
  return await httpClient.post<PostNotificationResponse>('user/v1/notification', {
    body: JSON.stringify({
      permission: params.permission,
    }),
  });
};
